import { Helmet } from "react-helmet";

export default function ReactHelmet({ title, description }) {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{title}</title>
        <meta name="description" content={description} />
      </Helmet>
    </>
  );
}
